import * as types from '../mutation-types/thumbnail-generator'

const namespaced = true
export const namespace = 'ThumbnailGenerator'

// state
const state = {
    requestThumbnailSetIds: [],
    thumbnailSets: {},
    thumbnailSetsUpdateIdx: 1,
}

// mutations
const mutations = {
    [types.ADD_REQUEST_THUMBNAIL_SET_ID](s, id) {
        if (!s.requestThumbnailSetIds.includes(id)) {
            s.requestThumbnailSetIds.push(id)
        }
        s.thumbnailSets[id].thumbnails[0].requested = true
        s.thumbnailSetsUpdateIdx++
    },
    [types.REMOVE_REQUEST_THUMBNAIL_SET_ID](s, id) {
        const idx = s.requestThumbnailSetIds.indexOf(id)
        if (idx >= 0) {
            s.requestThumbnailSetIds.splice(idx, 1)
        }
    },
    [types.UPDATE_THUMBNAIL_SET](s, thumbnailSet) {
        s.thumbnailSets[thumbnailSet.id] = thumbnailSet
        s.thumbnailSetsUpdateIdx++
    },
}

const actions = {
    addRequestThumbnailSetId({commit}, id) {
        commit(types.ADD_REQUEST_THUMBNAIL_SET_ID, id)
    },
    removeRequestThumbnailSetId({commit}, id) {
        commit(types.REMOVE_REQUEST_THUMBNAIL_SET_ID, id)
    },
    updateThumbnailSet({commit}, thumbnailSet) {
        commit(types.UPDATE_THUMBNAIL_SET, thumbnailSet)
    },
}

// getters
const getters = {
    requestThumbnailSetIds: s => {
        return s.requestThumbnailSetIds
    },
    thumbnailSets: s => {
        return s.thumbnailSetsUpdateIdx && s.thumbnailSets
    },
}

export default {namespaced, namespace, state, mutations, actions, getters}
